import { AxiosError } from 'axios';

export type ApiError = {
  message: string;

  code?: 'FORCE_LOGOUT' | 'PHONE_BLOCKED';
};

export function extractApiError(err: AxiosError) {
  return (err.response?.data || {
    message: 'Unknown Error',
  }) as ApiError;
}
